import CloseIcon from "@mui/icons-material/Close";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Tab,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useSnackbar } from "notistack";
import React, { Fragment, useEffect, useState } from "react";
import AuthService from "../../../../AuthService";
import { useConfirm } from "../../../../components/DialogConfirm";
import Utils from "../../../../utils";
import CompCadastroImagem from "../compCadastroImagem";
import DialogActionsButtons from "./components/DialogActionsButtons";
import DialogLoading from "./components/DialogLoading";
import TabComplements from "./components/TabComplements";
import TabDetails from "./components/TabDetails";
import TabSizes from "./components/TabSizes";

const CadastroProduto = (props) => {
  const {
    loading,
    open,
    produto: produtoProp,
    handleOpenCadProd,
    handleChangeProduto,
    grupo,
  } = props;

  const [state, setState] = useState({
    produto: produtoProp,
    complemento: null,
    compTamanho: null,
    grupos: [],
    locaisNotificacoes: [],
    grupoAnterior: null,
    hideButton: false,
    erros: {
      nomeProduto: null,
      localImpressao: null,
      descricaoComplemento: null,
      nomeItemComplemento: null,
      tamanho: null,
    },
    tamanhoItemEdicao: null,
  });

  const {
    produto,
    complemento,
    grupos,
    locaisNotificacoes,
    grupoAnterior,
    hideButton,
    erros,
    tamanhoItemEdicao,
  } = state;

  const confirm = useConfirm();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const optionsCurrency = Utils.optionsCurrency();
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = useState("1");

  useEffect(() => {
    handleListGroup();
    buscarLocaisNotificacao();
    setState((prev) => ({
      ...prev,
      produto: produtoProp,
      grupoAnterior: { ...produtoProp.grupoProduto }
    }));

    //eslint-disable-next-line
  }, [produtoProp]);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange = (event, newValue) => {
    const tempProduto = { ...produto };
    Utils.setValue(
      tempProduto,
      event.target.name,
      newValue || event.target.value
    );
    setState((prev) => ({ ...prev, produto: tempProduto }));
  };

  const handleChecked = (event) => {
    const tempProduto = { ...produto };
    tempProduto[event.target.name] = event.target.checked;
    setState((prev) => ({ ...prev, produto: tempProduto }));
  };

  const handleListGroup = () => {
    let service = new AuthService();
    service
      .get("/grupoProduto/list")
      .then((retorno) => {
        setState((prev) => ({ ...prev, grupos: retorno }));
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao listar grupo", { variant: "error" });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar("Falha ao listar grupo" + elem.errorMessage, {
              variant: "error",
            });
          });
        }
      });
  };

  const buscarLocaisNotificacao = () => {
    let service = new AuthService();
    service
      .get("/localNotificacao/list")
      .then((retorno) => {
        setState((prev) => ({ ...prev, locaisNotificacoes: retorno }));
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao buscar locais de notificação", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar(
              "Falha ao buscar locais de notificação" + elem.errorMessage,
              { variant: "error" }
            );
          });
        }
      });
  };

  const handleSubmit = (event) => {
    const tempErros = { ...erros };
    var erro = false;

    if (produto.nome === "") {
      tempErros.nomeProduto = "O nome do produto é obrigatório!";
      enqueueSnackbar("Preencha os campos requeridos (Campo: Nome)", {
        variant: "warning",
      });
      erro = true;
    } else {
      tempErros.nomeProduto = null;
    }

    if (produto.localImpressao === "") {
      tempErros.localImpressao = "O Local de impressão é obrigatório!";
      enqueueSnackbar(
        "Preencha os campos requeridos (Campo: Local de Impressão)",
        { variant: "warning" }
      );
      erro = true;
    } else {
      tempErros.localImpressao = null;
    }

    if (erro) {
      setState((prev) => ({ ...prev, erros: tempErros }));
      return;
    }

    const tempProduto = { ...produto };
    if (tempProduto.grupoProduto.id === 0) {
      tempProduto.grupoProduto.id = grupo;
    }

    tempProduto.grupoProduto = grupos.find(item => item.id === tempProduto.grupoProduto.id);

    let value = tempProduto.preco;
    let valueFormat = Utils.replaceValor(value);
    tempProduto.preco = valueFormat;

    let service = new AuthService();
    service
      .post("/produto", tempProduto)
      .then((retorno) => {
        enqueueSnackbar("Produto salvo com sucesso", { variant: "success" });
        handleChangeProduto(retorno, "SALVAR", grupoAnterior);
        setState((prev) => ({
          ...prev,
          produto: retorno,
          complemento: null,
          compTamanho: null,
          tamanhoItemEdicao: null,
        }));
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao tentar salvar o produto", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar("Falha ao salvar o produto " + elem.errorMessage, {
              variant: "error",
            });
          });
        }
      });
  };

  const handleDelete = async (produto) => {
    const confirmado = await confirm({
      message: "Deseja realmente excluir o produto?",
    });

    if (!confirmado) return;

    let service = new AuthService();
    service
      .delete(`/produto/${produto.id}`)
      .then((retorno) => {
        const tempProduto = { ...produto };
        tempProduto.ativo = false;
        setState((prev) => ({ ...prev, produto: tempProduto }));

        handleChangeProduto(retorno, "EXCLUIR");
        handleOpenCadProd();

        enqueueSnackbar("Produto inativado com sucesso", {
          variant: "success",
        });
      })
      .catch((err) => {
        enqueueSnackbar("Falha ao excluir o produto " + err.errorMessage, {
          variant: "error",
        });
      });
  };

  const validaComplemento = () => {
    if (parseInt(complemento.min) > parseInt(complemento.max)) {
      return {
        bool: true,
        text: "A quantidade máxima deve ser maior que a minima.",
      };
    } else if (complemento.obrigatorio && parseInt(complemento.max) <= 0) {
      return {
        bool: true,
        text: "O complemento não pode ser obrigatorio se o máximo for 0.",
      };
    }
    return false;
  };

  const handleClickStopAndPause = (event, item, complemento) => {
    event.stopPropagation();
    let service = new AuthService();
    let tempProduto = { ...produto };

    let string = `{ "id": ${item.id}, "produtoId": ${produto.id} }`;
    let json = JSON.parse(string);

    service.put("/complementoItem/play-or-pause", json).then((resp) => {
      let compItemIndex = complemento.complementoItens.findIndex(
        (el) => el.id === item.id
      );
      let compIndex = tempProduto.complementos.findIndex(
        (el) => el.id === complemento.id
      );

      tempProduto.complementos[compIndex].complementoItens[compItemIndex] =
        resp;

      handleChangeProduto(tempProduto, "SALVAR");
      handleSubmit();
    });
  };

  const handleDisableOrEnableComplement = (event, complemento) => {
    event.stopPropagation();
    let service = new AuthService();
    let tempProduto = { ...produto };

    let string = `{ "id": ${complemento.id}, "produtoId": ${produto.id} }`;
    let json = JSON.parse(string);

    service.put("/complemento/disable-or-enable-complement", json).then((resp) => {
      let compIndex = tempProduto.complementos.findIndex(
        (el) => el.id === complemento.id
      );

      tempProduto.complementos[compIndex] = resp;

      handleChangeProduto(tempProduto, "SALVAR");
      handleSubmit();
    })
  }

  if (!produto || loading) {
    return <DialogLoading open={open} handleOpenCadProd={handleOpenCadProd} />;
  }
  return (
    <Fragment>
      <Dialog
        fullScreen={isMobile}
        open={open}
        onClose={handleOpenCadProd}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          Cadastro de produtos
          <IconButton
            aria-label="close"
            sx={{
              position: "absolute",
              right: theme.spacing(1),
              top: theme.spacing(1),
              color: theme.palette.grey[500],
            }}
            onClick={handleOpenCadProd}
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ minHeight: "65vh", maxHeight: "95vh" }}>
          <TabContext value={value}>
            <Box pb={3}>
              <TabList onChange={handleChangeTab}>
                <Tab label="Detalhes" value="1" />
                <Tab disabled={!produto.id} label="Complementos" value="2" />
                <Tab disabled={!produto.id} label="Tamanhos" value="3" />
                <Tab disabled={!produto.id} label="Imagens" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <TabDetails
                produto={produto}
                erros={erros}
                optionsCurrency={optionsCurrency}
                grupos={grupos}
                locaisNotificacoes={locaisNotificacoes}
                handleChange={handleChange}
                handleChecked={handleChecked}
              />
            </TabPanel>
            <TabPanel value="2">
              <TabComplements
                complemento={complemento}
                erros={erros}
                optionsCurrency={optionsCurrency}
                produto={produto}
                validaComplemento={validaComplemento}
                handleClickStopAndPause={handleClickStopAndPause}
                handleDisableOrEnableComplement={handleDisableOrEnableComplement}
                handleSubmit={handleSubmit}
                handleChangeProduto={handleChangeProduto}
                grupoAnterior={grupoAnterior}
                setState={setState}
              />
            </TabPanel>
            <TabPanel value="3">
              <TabSizes
                tamanhoItemEdicao={tamanhoItemEdicao}
                erros={erros}
                optionsCurrency={optionsCurrency}
                produto={produto}
                setState={setState}
                handleClickStopAndPause={handleClickStopAndPause}
                handleDisableOrEnableComplement={handleDisableOrEnableComplement}
                handleSubmit={handleSubmit}
              />
            </TabPanel>
            <TabPanel value="4">
              <CompCadastroImagem
                produto={produto}
                handleChangeProduto={handleChangeProduto}
              />
            </TabPanel>
          </TabContext>
        </DialogContent>
        <DialogActionsButtons
          produto={produto}
          hideButton={hideButton}
          handleDelete={handleDelete}
          handleSubmit={handleSubmit}
        />
      </Dialog>
    </Fragment>
  );
};

export default CadastroProduto;
